import React from "react";
import { Link } from "react-router-dom";
import { ICollectionViewModel } from "Services/API/API";

export interface CollectionSharedProps {
   collection: ICollectionViewModel,
   accountName: string | undefined
}
export const CollectionPreferred: React.FC<CollectionSharedProps> = ({ collection, accountName }) => {

   const getImgUrl = (c :ICollectionViewModel) => {      
      let imgs = c.venues?.map(p => p.imageUrls).flat();

      if (imgs && imgs.length > 0) {
         return imgs[0];
      }

      return c.imageUrl;
   }

   return (
      <Link to={`/venues/${collection.id}`} className="collection-shared-wrapper" style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, .3), rgba(0, 0, 0, .3)), url(${getImgUrl(collection)})`, backgroundSize: "cover", backgroundPosition: "center", height: "280px" }}>
         <div className="inner container">
               {accountName && <div className="lbl1b by-account">by {accountName}</div>}
               <div className="h5 collection-name">{collection.name}</div>
         </div>
      </Link>
   );
}